document.addEventListener('DOMContentLoaded', () => {
    const fullScreenSlider = document.querySelectorAll('.slider-fullscreen .swiper');
    const contentSlider = document.querySelectorAll('.slider-content .swiper');
    const relatedSlider = document.querySelectorAll('.slider-related .swiper');

    if (fullScreenSlider) {
        fullScreenSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2.6,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3.5,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }

    if (contentSlider) {
        contentSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }

    if (relatedSlider) {
        relatedSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }
});
